"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GridColumnDataDisplayedType_1 = require("../GridColumnDataDisplayedType");
class StringRenderer {
    canRender(o) {
        return typeof o === "string" || o instanceof String;
    }
    render(ctx, str) {
        const trimmed = str.trim();
        const upperCasedString = trimmed.charAt(0).toUpperCase() + trimmed.substring(1);
        ctx.text(upperCasedString);
        ctx.setColumnDataDisplayType(GridColumnDataDisplayedType_1.GridColumnDataDisplayedType.STRING);
    }
}
exports.default = StringRenderer;
//# sourceMappingURL=StringRenderer.js.map